import { colors, STAGES } from "@/theme/colors";

/**
 * Home — placeholder. Phase 1 replaces with the real library view
 * (search / filter / status) per DESIGN.md §"Home e biblioteca local".
 */
export function Home() {
  return (
    <div style={{ maxWidth: 960 }}>
      <h2 style={{ fontSize: "var(--fs-display)", lineHeight: "var(--lh-display)" }}>
        Mesa de operação
      </h2>
      <p style={{ color: colors.textMuted, marginTop: "var(--space-tight)" }}>
        Ferramenta interna para revisão humana de PDFs vetorizados.
      </p>

      <section
        style={{
          marginTop: "var(--space-roomy)",
          padding: "var(--space-base)",
          background: colors.panel,
          border: `1px solid ${colors.line}`,
          borderRadius: "var(--radius-md)",
        }}
      >
        <h3 style={{ fontSize: "var(--fs-title)", lineHeight: "var(--lh-title)" }}>
          Etapas do fluxo
        </h3>
        <ol
          style={{
            marginTop: "var(--space-base)",
            display: "flex",
            flexDirection: "column",
            gap: 4,
            paddingLeft: 20,
          }}
        >
          {STAGES.map((s) => (
            <li key={s.id}>
              <span className="mono" style={{ color: colors.textMuted }}>
                {s.id}
              </span>{" "}
              {s.label}
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}
